"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
var Item_1 = require("./Item");
var EditableItem_1 = require("./EditableItem");
var Header_1 = require("./Header");
var SubHeader_1 = require("./SubHeader");
var DataGrid = function (_a) {
    var title = _a.title, icon = _a.icon, children = _a.children, materialIcon = _a.materialIcon, rightSection = _a.rightSection, style = _a.style, headerStyle = _a.headerStyle, className = _a.className, headerClassName = _a.headerClassName;
    return ((0, jsx_runtime_1.jsxs)(styles_1.DataGridContainer, __assign({ style: style, className: className }, { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, { title: title, icon: icon, materialIcon: materialIcon, rightSection: rightSection, style: headerStyle, className: headerClassName }), (0, jsx_runtime_1.jsx)(styles_1.Body, { children: children })] })));
};
DataGrid.Header = Header_1.Header;
DataGrid.SubHeader = SubHeader_1.SubHeader;
DataGrid.Column = styles_1.Column;
DataGrid.ColumnSection = styles_1.ColumnSection;
DataGrid.Item = Item_1.Item;
DataGrid.EditableItem = EditableItem_1.EditableItem;
exports.default = DataGrid;
